import React from 'react';
import PencilIcon from '@material-ui/icons/Edit';
import Console from '../../../lib/debug';

import * as ClipboardState from '../../../state/reducer/clipboard/clipboard';

export default class Editable extends React.Component {
    onFocus() {
        window.setTimeout(() => {
            ClipboardState.disableCalendarHotkeys();
            let editable = this.$editable,
                sel,
                range;
            if (window.getSelection && document.createRange) {
                range = document.createRange();
                range.selectNodeContents(editable);
                sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(editable);
                range.select();
            }
        }, 1);
    }

    onValueChange(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.props.onValueChanged(event.target.textContent);
            this.$editable.blur();
            ClipboardState.enableCalendarHotkeys();
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            this.$editable.blur();
            ClipboardState.enableCalendarHotkeys();
        }
        if (event.target.className.indexOf('edited') < 0) {
            event.target.className = event.target.className + ' edited';
        }
        return true;
    }

    updateValue(event) {
        window.getSelection().removeAllRanges();
        this.props.onValueChanged(event.target.textContent);
        ClipboardState.enableCalendarHotkeys();
    }

    render() {
        Console.render('designer.Editable');
        let pencil = this.props.preventEdit ? null : (
            <PencilIcon className="editable-icon" />
        );
        let classes = this.props.className
            ? `${this.props.className} click-area`
            : 'click-area';
        return (
            <div className="editable">
                <span
                    ref={el => (this.$editable = el)}
                    className={classes}
                    onFocus={this.onFocus.bind(this)}
                    contentEditable={!this.props.preventEdit}
                    onKeyDown={this.onValueChange.bind(this)}
                    onBlur={this.updateValue.bind(this)}
                    suppressContentEditableWarning
                >
                    <span>{this.props.value}</span>
                    {pencil}
                </span>
            </div>
        );
    }
}
